
//Live server URL below
const environment = {
    BASE_URL: "https://azproxy.e.org",
    debug: true,
    OTP_URL:"https://otpapi.e.org"
};


// Staging server URL below
// const environment = {
//     BASE_URL: "https://azproxyuat.e.org",
//     debug: true,
//     OTP_URL: "https://eotp.imobisoft.uk",
// };

export default environment;